// extracted by mini-css-extract-plugin
export var buttonContent = "_2q-0";
export var centered = "_2q-1";
export var centeredFlex = "_2q-2";
export var errorText = "_2q-3";
export var icon = "_2q-4";
export var iconButtonContent = "_2q-5";
export var monospace = "_2q-6";
export var padded = "_2q-7";